<template>
  <div :class="classes" v-loading="detailLoading">
    <pt-page-title title="奖励发放详情"></pt-page-title>
    <template v-if="!isShowRejectOparetion&&!isManualReward">
      <pt-sub-title title="奖励发放信息"></pt-sub-title>
      <audit-grant-message :isManualReward="isManualReward" :BringNewAuditDetail="BringNewAuditDetail" :coupon_list="coupon_list" :tdMaxWidth="maxWidthAll" @widthItem="widthItem"></audit-grant-message>
    </template>
    <template  v-if="showMotherMessage">
    <pt-sub-title title="母亲信息"></pt-sub-title>
      <health-order-message :userRegistration="userRegistration" :registrationEvent="registrationEvent" :mallOrderId="userRegistration.mallOrderId"></health-order-message>
    </template>
    <template v-if="!isManualReward">
     <pt-sub-title title="老用户信息"></pt-sub-title>
      <audit-customer-message :BringNewAuditDetail="BringNewAuditDetail" :customerMessage="oldCustomer"  :tdMaxWidth="maxWidthAll" userType="old"></audit-customer-message>
     <pt-sub-title title="新用户信息"></pt-sub-title>
      <audit-customer-message :BringNewAuditDetail="BringNewAuditDetail" :customerMessage="newCustomer"  :tdMaxWidth="maxWidthAll" userType="new"></audit-customer-message>
      </template>
    <template v-else>
    <pt-sub-title title="用户信息"></pt-sub-title>
    <table :class="$style['customer-message-old-to-new']" v-if="isManualReward">
      <pt-message-table-item label="奖励发放流水号" @widthItem="widthItem"  :tdMaxWidth="maxWidthAll">{{BringNewAuditDetail.number}}</pt-message-table-item>
      <pt-message-table-item label="生命银行用户" >{{BringNewAuditDetail.extendInformation&&BringNewAuditDetail.extendInformation.userName}}</pt-message-table-item>
      <pt-message-table-item label="C端手机号">{{BringNewAuditDetail.extendInformation&&BringNewAuditDetail.extendInformation.userMobile}}</pt-message-table-item>
      <template v-if="!isManualReward">
        <pt-message-table-item label="用户类型">{{BringNewAuditDetail.userType}}</pt-message-table-item>
        <pt-message-table-item label="奖励轮次">
          {{BringNewAuditDetail.extendInformation&&BringNewAuditDetail.extendInformation.customerBringNew&&BringNewAuditDetail.extendInformation.customerBringNew.finalRewardCount}}
          <!-- 第{{BringNewAuditDetail.extendInformation&&BringNewAuditDetail.extendInformation.rewardCount}}轮 -->
          </pt-message-table-item>
        <pt-message-table-item label="常住地区" v-if="BringNewAuditDetail.extendInformation&&BringNewAuditDetail.extendInformation.userType==='NEW'">
          <template v-if="BringNewAuditDetail.extendInformation.region">
            {{BringNewAuditDetail.extendInformation.region.provinceName+BringNewAuditDetail.extendInformation.region.cityName+BringNewAuditDetail.extendInformation.region.districtName}}
          </template>
          <template v-else>--</template>
        </pt-message-table-item>
        <pt-message-table-item label="CPS合同 ">
          <template v-if="BringNewAuditDetail.extendInformation&&BringNewAuditDetail.extendInformation.contractInformation&&
          BringNewAuditDetail.extendInformation.contractInformation.length">
          <div v-for="(item,i) in BringNewAuditDetail.extendInformation.contractInformation" :key="i">
            {{item.contractCode}} {{item.cpsRegion}} {{item.contract_date}}
          </div>
          </template>
          <!-- <div  :class="$style['CPS-number']">
          {{BringNewAuditDetail.extendInformation&&BringNewAuditDetail.extendInformation.CPSNumber}}
          </div> -->
          </pt-message-table-item>
         <!-- <pt-message-table-item label="地区 ">{{BringNewAuditDetail.extendInformation&&BringNewAuditDetail.extendInformation.cpsRegion}}</pt-message-table-item> -->
         <template v-if="isShowProduct">
           <pt-message-table-item label="产品名称">{{extendInformation.product_name}}</pt-message-table-item>
          <pt-message-table-item label="产品号">{{extendInformation.product_code}}</pt-message-table-item>
          <pt-message-table-item label="条码">{{extendInformation.bar_code}}</pt-message-table-item>
         </template>
        <!-- <pt-message-table-item label="合同签订时间">
          <div  :class="$style['CPS-number']">
          {{BringNewAuditDetail.extendInformation&&BringNewAuditDetail.extendInformation.contract_date}}
          </div>
          </pt-message-table-item> -->
      </template>
      <pt-message-table-item label="平台注册时间">{{BringNewAuditDetail.register_date}}</pt-message-table-item>
      <pt-message-table-item v-if="BringNewAuditDetail.achieve_date" label="达标时间">{{BringNewAuditDetail.achieve_date}}</pt-message-table-item>
    </table>
    </template>
    <template v-if="!isShowRejectOparetion&&isManualReward">
      <pt-sub-title title="奖励发放信息"></pt-sub-title>
      <audit-grant-message :isManualReward="isManualReward" :BringNewAuditDetail="BringNewAuditDetail" :coupon_list="coupon_list" :tdMaxWidth="maxWidthAll" @widthItem="widthItem"></audit-grant-message>
    </template>
    <template v-if="!isWaitingForAudit&&!isShowRejectOparetion">
      <pt-sub-title title="奖励审核信息"></pt-sub-title>
      <table :class="$style['customer-message-old-to-new']">
      <pt-message-table-item label="状态"  :tdMaxWidth="maxWidthAll">{{BringNewAuditDetail.audit_status}}</pt-message-table-item>
      <pt-message-table-item label="订单是否已退款">{{BringNewAuditDetail.alreadyRefund?'是':'否'}}</pt-message-table-item>
      <template v-if="BringNewAuditDetail.salesApproverName&&BringNewAuditDetail.salesApprovalDate">
      <pt-message-table-item label="客服审核人" >{{BringNewAuditDetail.salesApproverName}}</pt-message-table-item>
      <pt-message-table-item label="客服审核时间" :isRequested="isRequested" needRequest  @widthItem="widthItemSaler">{{BringNewAuditDetail.sales_approval_date}}</pt-message-table-item>
      <pt-message-table-item v-if="isSalesReject" label="客服驳回原因">{{BringNewAuditDetail.salesRejectReason}}</pt-message-table-item>
      <pt-message-table-item label="客服备注">{{BringNewAuditDetail.salesApprovalRemark}}</pt-message-table-item>
      <template v-if="!isSalesReject">
      <template v-if="BringNewAuditDetail.status==='COMPLETED'||isReject">
      <pt-message-table-item label="财务审核人" >{{BringNewAuditDetail.treasurerApproverName}}</pt-message-table-item>
      <pt-message-table-item :label="'财务审核时间'" :isRequested="isRequested" needRequest  @widthItem="widthItemSaler">{{BringNewAuditDetail.treasurer_approval_date}}</pt-message-table-item>
      <template v-if="isReject">
      <pt-message-table-item label="财务驳回原因" v-if="isReject">{{BringNewAuditDetail.treasurerRejectReason}}</pt-message-table-item>
      <pt-message-table-item label="财务备注">{{BringNewAuditDetail.treasurerApprovalRemark}}</pt-message-table-item>
      </template>
      <template v-else>
      <pt-message-table-item label="财务备注">{{BringNewAuditDetail.remark}}</pt-message-table-item>
      </template>
      </template>
      </template>
      </template>
        <template v-if="isShowRefundMessage">
        <pt-message-table-item v-if="BringNewAuditDetail.refundOperation&&BringNewAuditDetail.refundOperation.name" label="退款操作人">{{BringNewAuditDetail.refundOperation.name}}</pt-message-table-item>
        <pt-message-table-item v-if="BringNewAuditDetail.refundTime" label="退款时间">{{BringNewAuditDetail.refundTime}}</pt-message-table-item>
        <pt-message-table-item label="退款金额" v-if="BringNewAuditDetail.refundMoney"><span :class="$style['refund-money-class']">{{BringNewAuditDetail.refundMoney}}</span>元</pt-message-table-item>
         <pt-message-table-item label="退款原因" v-if="BringNewAuditDetail.refundInfo&&BringNewAuditDetail.refundInfo.reason">{{BringNewAuditDetail.refundInfo&&BringNewAuditDetail.refundInfo.reason}}</pt-message-table-item>
        <pt-message-table-item label="退款订单">
          <router-link :to="'/mall-order-refund/order-detail/'+orderId" :class="$style['get-order-detail-link']">订单详情</router-link>
      </pt-message-table-item>
      </template>
      </table>
      <!-- <div class="button-div" v-if="!isManualReward">
       <el-button type="primary" @click="returnEdit" :loading="submitLoading" v-if="isShowReturnEdit">返回修改</el-button>
      </div> -->
    </template>
    <template v-if="isShowApproveOrRufundForm">
      <pt-sub-title v-if="showRefund" title="退款"></pt-sub-title>
      <award-grant-review  :selectRows="selectRows"  :isManualReward="isManualReward" fromPage="detail" @closeDialog="closeDialog" :auditStatus="auditStatus" :userType="userType"></award-grant-review>
    </template>
      <template v-if="isShowRejectOparetion">
        <pt-sub-title :title="customerTitle"></pt-sub-title>
         <customer-message @formValue="formValue" :customer="BringNewAuditDetail" :isEditCoupons="isEditNewCoupons"  isReject></customer-message>
         <div class="button-div">
              <el-button type="primary" @click="submitReview" :loading="submitLoading">提交审核</el-button>
              <!-- <el-button type="primary" plain @click="cancel">取消</el-button> -->
          </div>
      </template>
  </div>
</template>

<script>
// 组件class前缀
import customerMessage from 'cps/mall-manage/pt-old-to-new/pt-old-to-new-detail/customer-message'
import auditCustomerMessage from './customer-message'
import auditGrantMessage from './audit-grant-message'
import { cashCount, isEmptyObject } from '@/utils/formUtils'
import { hasPermissions } from 'utils/permissions'
import awardGrantReview from '../award-grant-review'
import healthOrderMessage from 'cps/goods-order/health-order-message'
const prefixCls = 'pt-award-audit-detail'
const PERM_MALLSALES_MANUAL_REWARD_AUDIT = 'PERM_MALLSALES_MANUAL_REWARD_AUDIT'// 手动发放奖励审核权限

const PERM_MANUAL_CUSTOMER_AUDIT = 'PERM_MANUAL_CUSTOMER_AUDIT'// 手动发放奖励客服审核权限
const PERM_MALLSALES_BRING_NEW_REWARD_AUDIT = 'PERM_MALLSALES_BRING_NEW_REWARD_AUDIT'// 老带新财务审核权限
const PERM_BRING_NEW_REWARD_CUSTOMER_AUDIT = 'PERM_BRING_NEW_REWARD_CUSTOMER_AUDIT'// 老带新客服审核权限
const PERM_APPROVAL_ROUND_FIRST = 'PERM_APPROVAL_ROUND_FIRST'// 脐荐康第一轮奖励审核
const PERM_APPROVAL_ROUND_SECOND = 'PERM_APPROVAL_ROUND_SECOND'// 脐荐康第二轮奖励审核
const PERM_APPROVAL_ROUND_THIRD = 'PERM_APPROVAL_ROUND_THIRD'// 脐荐康第三轮奖励审核
export default {
  name: 'pt-award-audit-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    form () {
      return this.$refs.review
    },
    showMotherMessage () {
      return this.registrationEvent && !isEmptyObject(this.registrationEvent) && this.userRegistration && !isEmptyObject(this.userRegistration)
    },
    // 脐荐康第一轮奖励审核权限
    HAS_PERM_APPROVAL_ROUND_FIRST () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_APPROVAL_ROUND_FIRST)
    },
    // 脐荐康第二轮奖励审核权限
    HAS_PERM_APPROVAL_ROUND_SECOND () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_APPROVAL_ROUND_SECOND)
    },
    // 脐荐康第三轮奖励审核权限
    HAS_PERM_APPROVAL_ROUND_THIRD () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_APPROVAL_ROUND_THIRD)
    },
    rewardCountToPerm () {
      let row = this.BringNewAuditDetail
      let rewardCount = row.extendInformation && row.extendInformation.customerBringNew && row.extendInformation.customerBringNew.finalRewardCount
      return (rewardCount === '第一轮' && this.HAS_PERM_APPROVAL_ROUND_FIRST) || (rewardCount === '第二轮' && this.HAS_PERM_APPROVAL_ROUND_SECOND) ||
      (rewardCount === '第三轮' && this.HAS_PERM_APPROVAL_ROUND_THIRD)
    },
    // 手动发放奖励财务审核权限
    HAS_MANUAL_AUDIT () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_MALLSALES_MANUAL_REWARD_AUDIT)
    },
    // 手动发放奖励客服审核权限
    HAS_MANUAL_CUSTOMER_AUDIT () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_MANUAL_CUSTOMER_AUDIT)
    },
    // 老带新奖励财务审核权限
    HAS_BRING_NEW_AUDIT () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_MALLSALES_BRING_NEW_REWARD_AUDIT)
    },
    // 老带新客服审核权限
    HAS_BRING_NEW_CUSTOMER_AUDIT () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_BRING_NEW_REWARD_CUSTOMER_AUDIT)
    },
    // 判断是否显示审核操作
    isShowReview () {
      return this.BringNewAuditDetail.status === 'SALES_COMPLETED'
    },
    // 待客服审核
    isWaitingForAudit () {
      return this.BringNewAuditDetail.status === 'WAITING_FOR_APPROVAL'
    },
    // 根据权限，显示审核操作（财务审核）
    isFinanceAudit () {
      let status = this.BringNewAuditDetail.status
      return (status === 'SALES_COMPLETED' && this.businessType === 'CUSTOMER_BRING_NEW_QJK')
        ? (this.HAS_BRING_NEW_AUDIT && this.rewardCountToPerm)
        : ((this.HAS_BRING_NEW_AUDIT || this.HAS_MANUAL_AUDIT) && this.isShowReview)
    },
    businessType () {
      return this.BringNewAuditDetail.businessType
    },
    // 根据权限判断显示审核操作(是否客服审核)
    isShowReviewPeomission () {
      let status = this.BringNewAuditDetail.status
      return ((status === 'WAITING_FOR_APPROVAL') &&
      this.businessType === 'CUSTOMER_BRING_NEW_QJK')
        ? (this.HAS_BRING_NEW_CUSTOMER_AUDIT && this.rewardCountToPerm)
        : ((this.HAS_BRING_NEW_CUSTOMER_AUDIT || this.HAS_MANUAL_CUSTOMER_AUDIT) &&
        (this.isWaitingForAudit || (!this.isManualReward && this.BringNewAuditDetail.status === 'REJECTED')))
    },
    // 是否状态是已驳回
    isReject () {
      return this.BringNewAuditDetail.status === 'REJECTED'
    },
    isSalesReject () {
      return this.BringNewAuditDetail.status === 'SALES_REJECTED'
    },
    // 已审核状态
    isCompleted () {
      return this.BringNewAuditDetail.status === 'COMPLETED'
    },
    //
    extendInformation () {
      return this.BringNewAuditDetail.extendInformation || {}
    },
    customerBringNew () {
      return this.extendInformation.customerBringNew || {}
    },
    // 新用户信息
    newCustomer () {
      return this.customerBringNew.newCustomer || {}
    },
    // 老用户信息
    oldCustomer () {
      return this.customerBringNew.oldCustomer || {}
    },
    // 用户奖励修改标题
    customerTitle () {
      return (this.BringNewAuditDetail.extendInformation && this.BringNewAuditDetail.extendInformation.userType === 'OLD') ? '老用户奖励' : '新用户奖励'
    },
    userType () {
      return (this.BringNewAuditDetail.extendInformation && this.BringNewAuditDetail.extendInformation.userType) || null
    },
    // 是否显示审核信息
    isShowReviewMessage () {
      return this.BringNewAuditDetail.status !== 'WAITING_FOR_APPROVAL'
    },
    // 是否显示返回修改的按钮
    isShowReturnEdit () {
      return this.BringNewAuditDetail.status === 'SALES_REJECTED'
    },
    maxWidthAll () {
      if (this.maxWidthSaler > this.maxWidth) {
        return this.maxWidthSaler
      } else {
        return this.maxWidth
      }
    },
    show_approval_message () {
      return (this.BringNewAuditDetail.status === 'SALES_COMPLETED' || this.BringNewAuditDetail.status === 'SALES_REJECTED') ? '(客服审核)'
        : (this.BringNewAuditDetail.status === 'COMPLETED' || this.BringNewAuditDetail.status === 'REJECTED') ? '(财务审核)' : ''
    },
    show_reject_message () {
      return this.BringNewAuditDetail.status === 'SALES_REJECTED' ? '(客服审核)' : (this.BringNewAuditDetail.status === 'REJECTED') ? '(财务审核)' : ''
    },
    // 是否显示产品相关信息（新用户显示）
    isShowProduct () {
      return this.BringNewAuditDetail.extendInformation && this.BringNewAuditDetail.extendInformation.userType === 'NEW'
    },
    // 是否可退款
    isRefund () {
      return this.BringNewAuditDetail.status === 'COMPLETED' && this.BringNewAuditDetail.businessType === 'CUSTOMER_BRING_NEW_QJK' && this.BringNewAuditDetail.extendInformation &&
      this.BringNewAuditDetail.extendInformation.customerBringNew && this.BringNewAuditDetail.extendInformation.customerBringNew.finalRewardCount === '第一轮'
    },
    showRefund () {
      return this.BringNewAuditDetail.showRefund && (this.HAS_BRING_NEW_AUDIT || this.HAS_BRING_NEW_CUSTOMER_AUDIT)
    },
    isShowApproveOrRufundForm () {
      return this.isShowReviewPeomission || this.isFinanceAudit || this.showRefund
    },
    orderId () {
      return this.BringNewAuditDetail.extendInformation && this.BringNewAuditDetail.extendInformation.businessId
    },
    // 是否是脐荐康第一轮奖励驳回状态
    isFirstReject () {
      return this.BringNewAuditDetail.status === 'SALES_REJECTED' && this.BringNewAuditDetail.extendInformation &&
      this.BringNewAuditDetail.extendInformation.customerBringNew &&
      this.BringNewAuditDetail.extendInformation.customerBringNew.bringNewCode === 'QJK' &&
      this.BringNewAuditDetail.extendInformation.customerBringNew.finalRewardCount === '第一轮'
    },
    // 是否显示退款信息
    isShowRefundMessage () {
      return (this.BringNewAuditDetail.status === 'REFUND' || this.isFirstReject) && this.BringNewAuditDetail.extendInformation && this.BringNewAuditDetail.extendInformation.businessId
    }
  },
  components: {
    // reviewOpretion,
    awardGrantReview,
    customerMessage,
    auditGrantMessage,
    auditCustomerMessage,
    healthOrderMessage
  },
  props: {
    userRegistration: {
      type: Object
    },
    registrationEvent: {
      type: Object
    },
    auditStatus: {
      type: String
    },
    isManualReward: {
      type: Boolean,
      default: false
    },
    BringNewAuditDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    submitLoading: {
      type: Boolean,
      default: false
    },
    reviewLoading: {
      type: Boolean,
      default: false
    },
    detailLoading: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      maxWidth: '',
      coupon_list: [],
      isEditNewCoupons: true,
      isShowRejectOparetion: false,
      customerMessage: {},
      maxWidthSaler: null,
      isRequested: false,
      customerMessageTitle: null,
      selectRows: []
    }
  },
  watch: {
    BringNewAuditDetail: {
      handler: function (val) {
        this.selectRows.push(val)
        this.isRequested = true
        let list = []
        if (val.reward && val.reward.discountCoupons) {
          list = JSON.parse(JSON.stringify(val.reward.discountCoupons))
        }
        if (list && list.length > 0) {
          list.forEach(item => {
            this.coupon_list.push({ ...item.discountCoupon, ...item })
          })
        }
      },
      deep: true
    }
  },
  methods: {
    closeDialog (val) {
      if (val) {
        this.$emit('getDetail')
      }
    },
    widthItemSaler (val) {
      this.$set(this, 'maxWidthSaler', val)
      // this.maxWidthSaler = val
    },
    returnEdit () {
      this.isShowRejectOparetion = true
    },
    submitReview () {
      let data = {
        ids: [],
        newDiscountCoupons: null,
        oldDiscountCoupons: null
      }
      if (this.BringNewAuditDetail.extendInformation.userType === 'NEW') {
        data.newMoney = this.customerMessage.amount ? cashCount(this.customerMessage.amount) : null
        if (this.customerMessage.coupon_list && this.customerMessage.coupon_list.length > 0) {
          data.newDiscountCoupons = []
          this.customerMessage.coupon_list.forEach(item => {
            data.newDiscountCoupons.push({ id: item.id, amount: item.amount })
          })
        }
      } else if (this.BringNewAuditDetail.extendInformation.userType === 'OLD') {
        data.oldMoney = this.customerMessage.amount ? cashCount(this.customerMessage.amount) : null
        if (this.customerMessage.coupon_list && this.customerMessage.coupon_list.length > 0) {
          data.oldDiscountCoupons = []
          this.customerMessage.coupon_list.forEach(item => {
            data.oldDiscountCoupons.push({ id: item.id, amount: item.amount })
          })
        }
      }
      data.ids.push(this.id)
      this.$emit('submitReview', data)
    },
    formValue (val) {
      this.customerMessage = val
    },
    cancel () {
      history.go(-1)
    },
    widthItem (val) {
      console.log('widthItem+++', val)
      this.maxWidth = val
    }
  }
}
</script>

<style module lang="less">
@import "~less/var";
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.CPS-number{
  word-break: break-all
}
.refund-money-class{
  color:  @mainColor;
  font-weight: 600;
  margin-right: 5px
}
.customer-message-old-to-new{
  padding: 0 20px;
  :global
  .pt-message-table-item{
    :first-child{
      // width: 114PX
    }
  }
}
.money-reward-amount{
  color: @mainColor;
  font-weight: 600;
  font-size: 17px;
  margin-right: 5px;
}
.get-order-detail-link{
  color:  @mainColor;
}
</style>
